import { FC } from "react";
import Image from "next/image";
import { useRouter } from "next/router";

import { imageLoader, getMediaSizes } from "@utils/get-media";
import { SupplierWithCategories } from "@interfaces/supplier";

type Props = Pick<SupplierWithCategories, "name" | "url" | "featuredPhoto"> &
  Partial<Pick<SupplierWithCategories, "supplierToCategory">> & {
    showName?: boolean;
  };

const SupplierCard: FC<Props> = ({
  name,
  url,
  featuredPhoto,
  supplierToCategory,
  showName,
}) => {
  const { locale } = useRouter();

  return (
    <a
      href={url}
      target="_blank"
      rel="noreferrer"
      className="block p-4 space-y-2 w-full"
    >
      <div className="aspect-w-1 aspect-h-1">
        <Image
          src={featuredPhoto}
          loader={imageLoader}
          alt={name}
          layout="fill"
          objectFit="cover"
          sizes={getMediaSizes([
            { breakpoint: "sm", size: "100vw" },
            { breakpoint: "md", size: "50vw" },
            { breakpoint: "lg", size: "33vw" },
            { size: "25vw" },
          ])}
        />
      </div>
      {showName && (
        <div className="text-lg font-semibold text-center">{name}</div>
      )}
      {supplierToCategory && supplierToCategory.length > 0 && (
        <div className="text-sm text-gray-500 italic text-center">
          {supplierToCategory
            .map(({ category: { name, nameEn } }) =>
              locale === "en" ? nameEn : name
            )
            .join(" / ")}
        </div>
      )}
    </a>
  );
};

export default SupplierCard;
